import { j as o } from "./AccesRecoveryIcon-CUPieIxT.js";
const n = () => /* @__PURE__ */ o.jsx("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ o.jsx(
  "path",
  {
    d: "M16.666 11.667a11.667 11.667 0 0 0 20 8.167V20c0 9.205-7.461 16.667-16.666 16.667S3.333 29.205 3.333 20 10.795 3.334 20 3.334h.166a11.63 11.63 0 0 0-3.5 8.333M6.666 20a13.334 13.334 0 0 0 25.104 6.27A15 15 0 0 1 13.73 8.23 13.33 13.33 0 0 0 6.666 20",
    fill: "currentColor"
  }
) });
export {
  n as M
};
